
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 52 26","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M24.014.316l3.482 19.747c.196 1.115-.297 2.128-1.106 2.27L5.942 25.94c-.809.142-1.619-.64-1.815-1.755l-.639-3.622L1.004 6.476c-.196-1.115.297-2.127 1.106-2.27L22.535.579c.016.027.509-.06 1.48-.263zM26.102 0l.608.003 23.315.024a1.98 1.98 0 011.97 1.846l.005.149v3.59H39.753c-1.031 0-1.894.823-1.97 1.847l-.005.148v6.383c0 1.041.815 1.912 1.829 1.989l.146.006H52v3.59a1.982 1.982 0 01-1.827 1.989l-.148.005-20.632.001a2.13 2.13 0 00.282-1.254l-.026-.193L26.102 0zm-1.993 12.61a.98.98 0 00-1.137-.791L6.854 14.716a.994.994 0 00-.802 1.153.98.98 0 001.138.792l16.117-2.897a.994.994 0 00.802-1.154zm-1.29-5.924a.98.98 0 00-1.137-.791L5.564 8.792a.994.994 0 00-.802 1.153.98.98 0 001.138.791L22.017 7.84a.994.994 0 00.802-1.153z"}}),_c('path',{attrs:{"d":"M39.753 7.208a.38.38 0 00-.395.399v6.383a.38.38 0 00.395.4H52V7.207H39.753z"}})])])
          )
        }
      }
    